import React from "react";

import axios from "axios";
import { useSelector } from "react-redux";
import { Jumbotron } from "./migration";

const pictureLinkRegex = new RegExp(
	/[(http(s)?):(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/
);

const AboutMe = ({ heading, message, link, imgSize, resume }) => {
	const [profilePicUrl, setProfilePicUrl] = React.useState("");
	const [showPic, setShowPic] = React.useState(Boolean(link));
	// https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
	React.useEffect(() => {
		const handleRequest = async () => {
			const instaLink = "https://www.instagram.com/";
			const instaQuery = "/?__a=1";
			try {
				const response = await axios.get(instaLink + link + instaQuery);
				setProfilePicUrl(response.data.graphql.user.profile_pic_url_hd);
			} catch (error) {
				setShowPic(false);
				console.error(error.message);
			}
		};

		if (link && !pictureLinkRegex.test(link)) {
			handleRequest();
		} else {
			setProfilePicUrl(link);
		}
	}, [link]);

	const setLanguage = useSelector((state) => state.estado.value);
	let headingResume = "Resume";
	if (setLanguage === false) {
		message =
			`Com formação em Engenharia Elétrica e Inteligência Artificial, construí uma carreira voltada à criação de soluções tecnológicas que conectam eficiência, inovação e impacto real. Especializado em ServiceNow, atuo na análise, desenvolvimento e otimização de fluxos de trabalho digitais, ajudando empresas a transformar processos complexos em experiências simples e eficazes.

			Sou certificado em ServiceNow System Administration e AWS, além de possuir formações complementares em Java, JavaScript e React, o que me permite transitar com facilidade entre o front-end, o back-end e a integração de sistemas.

			Tenho atuado em projetos de consultoria para grandes organizações como NTT e Ambev, desenvolvendo e mantendo o Service Portal, implementando automações, integrações e garantindo que cada entrega atenda plenamente às necessidades do negócio.

			Estou sempre em busca de novos desafios que me permitam aplicar minha expertise técnica e colaborar na construção de soluções digitais escaláveis e transformadoras.`;
		headingResume = "Currículo";
		heading = "Sobre mim";
	}

	return (
		<Jumbotron id="aboutme" className="m-0">
			<div id="aboutMeContainer" className="container row">
				<div id="imageContainer" className="col-5 align-self-center">
					{showPic && (
						<img
							className="border border-secondary rounded-circle"
							src={profilePicUrl}
							alt="profilepicture"
							width={imgSize}
							height={imgSize}
							id="profileImage"
						/>
					)}
				</div>
				<div
					id="aboutMeTextContainer"
					className={`col-lg-${showPic ? "7" : "12"}`}
				>
					<h2 className="display-4 mb-5 text-center">{heading}</h2>
					{/* <p className="lead text-center">{message}</p> */}
					<p className="lead text-center" style={{ whiteSpace: "pre-line" }}>{message}</p>
					{(
						<p className="lead text-center">
							<a
								className="btn btn-outline-dark btn-lg"
								href={resume}
								target="_blank"
								rel="noreferrer noopener"
								role="button"
								aria-label="Resume/CV"
							>
								{headingResume}
							</a>
						</p>
					)}
				</div>
			</div>
		</Jumbotron>
	);
};

export default AboutMe;
